import TableComponent from "components/Table"
import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Col, Row } from "reactstrap"
import { getFormBuilderPaymentReports } from "store/actions"
import { getCurrentTimeZone } from "containers/Communications/utils"
import formBuilderTransactionsListColumns from "./formBuilderTransactionsListColumns"
import { Link } from "react-router-dom"
import { URL_PATHS } from "constants/index"
import { SaveButton } from "components/Buttons"

const BookingTransactions = ({
  getFormBuilderPaymentReports,
  formBuilderPaymentReports,
  handleRemoveWidget,
}) => {
  useEffect(() => {
    getFormBuilderPaymentReports({
      o: "created_at",
      od: "desc",
      page: 1,
      per_page: 5,
      timezone: getCurrentTimeZone(),
    })
  }, [])

  const handleSort = (type, { sortField, sortOrder }) => {
    getFormBuilderPaymentReports({
      o: sortField,
      od: sortOrder,
      page: 1,
      per_page: 5,
      timezone: getCurrentTimeZone(),
    })
  }

  return (
    <Col xs={12}>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <h5>Form Payment Reports</h5>
            </Col>{" "}
            <Col xs="auto">
              <i
                className="bx bx-x font-size-22"
                style={{ cursor: "pointer" }}
                onClick={handleRemoveWidget}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <TableComponent
                data={
                  formBuilderPaymentReports?.data
                    ?.slice(0, 5)
                    ?.map((item, index) => ({
                      ...item,
                      id: index,
                    })) || []
                }
                columns={formBuilderTransactionsListColumns()}
                onTableSort={handleSort}
                loadingData={!formBuilderPaymentReports}
              />
            </Col>
          </Row>
          <Row className="d-flex justify-content-end">
            <Col xs="auto">
              <Link to={URL_PATHS.FORM_PAYMENT_REPORTS}>
                <SaveButton
                  type="button"
                  color="primary"
                  content="View More"
                  size="sm"
                />
              </Link>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

const mapStateToProps = state => ({
  formBuilderPaymentReports: state.Analytics.formBuilderPaymentReports,
})

const mapDispatchToProps = dispatch => ({
  getFormBuilderPaymentReports: values =>
    dispatch(getFormBuilderPaymentReports(values)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BookingTransactions)
